import { useNavigate, useLocation } from "react-router-dom";
import { IconCompass } from "@/components/icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguage, SUPPORTED_LANGUAGES, type LanguageCode } from "@/contexts/LanguageContext";
import { useLocalizedUrl } from "@/hooks/use-localized-routes";

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const { localizeUrl, resolveLocalizedUrl } = useLocalizedUrl();
  const navigate = useNavigate();
  const location = useLocation();

  function handleChange(newLang: string) {
    const lang = newLang as LanguageCode;
    setLanguage(lang);

    // Resolve current path to canonical first (in case we're already on a localized URL)
    const { canonicalPath } = resolveLocalizedUrl(location.pathname);
    // Then localize to the new language
    const newPath = localizeUrl(canonicalPath, lang);
    navigate(newPath + location.search + location.hash, { replace: true });
  }

  return (
    <Select value={language} onValueChange={handleChange}>
      <SelectTrigger className="w-auto gap-1.5 border-none shadow-none h-9 text-sm">
        <IconCompass className="h-4 w-4 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
